export interface INotification {
    ntfText?: string;
    ctaText?: string;
    ctaUrl?: string;
    icon?: string;
    displayDateFormat?: string;
    isRead: boolean;
    userNTFGUID: string;
}

export interface INotificationsResponse {
    data: {
        count: number;
        notifications: INotification[];
    },
    statusCode: number,
    errors?: string[],
}

export enum NotificationAction {
    See = 1,
    Read = 2,
    Unread = 3,
    Click = 4,
    Clear = 5,
}